/**
 * This class has generic method to convert URL object to string and vice versa
 */
export class URLHelper {
    constructor() {

    }

     /**
   * Build generic URL object by existing url and dictionary used as to track query string;
   * 
   * @param url url to add query string
   * @param dictionaryQueryString dictionary to generate query string
   * @returns 
   */
    public buildFullURLByQueryString(url: URL, dictionaryQueryString: Map<string, string>): URL {
        for (const key of dictionaryQueryString.keys()) {
             url.searchParams.set(key, dictionaryQueryString.get(key))
        }

        return url;
    }
}